import { endWinStreakAndOpenShare } from './endWinStreakAndOpenShare';
import { findActiveWinStreakConfig } from '../findActiveWinStreakConfig';
import { openWinStreakRoadPopup } from './openWinStreakRoadPopup';
import { updateWinStreakActivity, getChestToOpenIndex, startWinStreakEvent } from '../WinStreakUtils';
import type { WinStreakDependencies } from '../WinStreakController';

interface WinStreakFlowDependencies {
  dependencies: WinStreakDependencies;
  playLevelAction: () => void;
}

async function activeWinStreakFlow(config: WinStreakFlowDependencies): Promise<void> {
  const { dependencies, playLevelAction } = config;

  const winStreakState = dependencies.observable.getValue().winStreakActiveEvent;
  if (!winStreakState) return;

  if (getChestToOpenIndex(winStreakState) === -1) return;

  await openWinStreakRoadPopup({
    dependencies,
    onPlayClicked: playLevelAction,
    intro: false,
  });
}

async function inactiveWinStreakFlow(config: WinStreakFlowDependencies): Promise<void> {
  const { dependencies, playLevelAction } = config;

  const availableWinStreak = findActiveWinStreakConfig(dependencies);

  if (!availableWinStreak) return;

  const { id } = startWinStreakEvent(dependencies.observable, availableWinStreak);

  dependencies.tracking.onEventStart(id);

  await openWinStreakRoadPopup({
    dependencies,
    onPlayClicked: playLevelAction,
    intro: true,
  });
}

export async function startMainMenuWinStreakFlow(config: WinStreakFlowDependencies): Promise<void> {
  const { dependencies } = config;

  updateWinStreakActivity(dependencies);

  const winStreakData = dependencies.observable.getValue().winStreakActiveEvent;

  if (winStreakData === null) {
    await inactiveWinStreakFlow(config);
  } else if (winStreakData.finished && getChestToOpenIndex(winStreakData) === -1) {
    await endWinStreakAndOpenShare(dependencies);
  } else {
    await activeWinStreakFlow(config);
  }
}
